<template>
  <div class="loading-wrapper">
    <div class="animation-wrapper loaded">
      <div class="wordmark">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 186.8 34.5"
          style="enable-background:new 0 0 186.8 34.5;"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                class="st0"
                d="M100.3,17.6l0.1,1.6c1.1-1.2,2.5-1.8,4.3-1.8c2,0,3.4,0.8,4.1,2.3c1.1-1.5,2.6-2.3,4.6-2.3
			c1.6,0,2.9,0.5,3.7,1.4s1.2,2.3,1.2,4v9.8h-3.4v-9.7c0-0.9-0.2-1.6-0.6-2.1c-0.4-0.4-1.1-0.7-2.1-0.7c-0.8,0-1.4,0.2-1.9,0.6
			s-0.8,0.9-1,1.6l0,10.3H106v-9.8c0-1.8-0.9-2.6-2.7-2.6c-1.3,0-2.3,0.5-2.9,1.6v10.8h-3.4v-15C97.1,17.6,100.3,17.6,100.3,17.6z"
              />
              <path
                class="st0"
                d="M127.1,32.9c-2.1,0-3.9-0.7-5.2-2c-1.3-1.3-2-3.1-2-5.4v-0.4c0-1.5,0.3-2.8,0.9-4c0.6-1.2,1.4-2.1,2.4-2.7
			c1-0.7,2.2-1,3.5-1c2,0,3.6,0.6,4.7,1.9c1.1,1.3,1.7,3.1,1.7,5.5v1.4h-9.8c0.1,1.2,0.5,2.2,1.2,2.9c0.7,0.7,1.6,1.1,2.7,1.1
			c1.5,0,2.8-0.6,3.8-1.9l1.8,1.7c-0.6,0.9-1.4,1.6-2.4,2.1C129.5,32.6,128.4,32.9,127.1,32.9z M126.7,20.1c-0.9,0-1.7,0.3-2.2,1
			c-0.6,0.6-0.9,1.5-1.1,2.7h6.4v-0.2c-0.1-1.1-0.4-2-0.9-2.6C128.4,20.3,127.6,20.1,126.7,20.1z"
              />
              <path
                class="st0"
                d="M139.2,14v3.6h2.6v2.5h-2.6v8.3c0,0.6,0.1,1,0.3,1.2c0.2,0.3,0.6,0.4,1.2,0.4c0.4,0,0.8,0,1.2-0.1v2.6
			c-0.8,0.2-1.5,0.3-2.2,0.3c-2.6,0-3.9-1.4-3.9-4.3v-8.5h-2.5v-2.5h2.5V14H139.2z"
              />
              <path
                class="st0"
                d="M151.4,20.7c-0.4-0.1-0.9-0.1-1.4-0.1c-1.5,0-2.6,0.6-3.1,1.8v10.2h-3.4v-15h3.2l0.1,1.7
			c0.8-1.3,1.9-1.9,3.4-1.9c0.5,0,0.9,0.1,1.2,0.2L151.4,20.7z"
              />
              <path class="st0" d="M156.2,32.6h-3.4v-15h3.4V32.6z" />
              <path
                class="st0"
                d="M164.5,30.2c0.8,0,1.5-0.2,2.1-0.7c0.6-0.5,0.8-1.1,0.9-1.8h3.2c0,0.9-0.3,1.8-0.9,2.6
			c-0.5,0.8-1.3,1.4-2.2,1.9c-0.9,0.5-1.9,0.7-3,0.7c-2.1,0-3.8-0.7-5-2c-1.2-1.4-1.8-3.2-1.8-5.6v-0.3c0-2.3,0.6-4.1,1.8-5.5
			c1.2-1.4,2.9-2.1,5-2.1c1.8,0,3.2,0.5,4.3,1.6s1.7,2.4,1.8,4.1h-3.2c0-0.9-0.3-1.6-0.9-2.1c-0.5-0.6-1.2-0.8-2.1-0.8
			c-1.1,0-1.9,0.4-2.5,1.2c-0.6,0.8-0.9,2-0.9,3.6v0.5c0,1.6,0.3,2.8,0.9,3.6C162.6,29.8,163.4,30.2,164.5,30.2z"
              />
              <path
                class="st0"
                d="M180.8,28.5c0-0.6-0.2-1.1-0.7-1.4s-1.3-0.6-2.5-0.8c-1.1-0.2-2.1-0.5-2.9-0.9c-1.7-0.8-2.5-2-2.5-3.5
			c0-1.3,0.5-2.4,1.6-3.2c1.1-0.9,2.5-1.3,4.1-1.3c1.8,0,3.2,0.4,4.3,1.3c1.1,0.9,1.7,2,1.7,3.4h-3.4c0-0.6-0.2-1.2-0.7-1.6
			c-0.5-0.4-1.1-0.6-1.9-0.6c-0.7,0-1.3,0.2-1.8,0.5c-0.5,0.3-0.7,0.8-0.7,1.4c0,0.5,0.2,0.9,0.6,1.2c0.4,0.3,1.3,0.6,2.6,0.9
			c1.3,0.3,2.4,0.6,3.1,1c0.8,0.4,1.3,0.9,1.7,1.4c0.4,0.6,0.5,1.2,0.5,2c0,1.3-0.6,2.4-1.7,3.3c-1.1,0.8-2.6,1.3-4.4,1.3
			c-1.2,0-2.3-0.2-3.3-0.7c-1-0.4-1.7-1.1-2.2-1.8c-0.5-0.8-0.8-1.6-0.8-2.5h3.3c0,0.8,0.3,1.4,0.9,1.8c0.6,0.4,1.3,0.6,2.2,0.6
			c0.9,0,1.6-0.2,2-0.5C180.6,29.5,180.8,29.1,180.8,28.5z"
              />
            </g>
            <g>
              <g>
                <polygon
                  class="st1"
                  points="47.8,32.5 44.3,27.2 40.7,32.5 36.2,32.5 41.7,24.5 36.5,17 41.1,17 44.3,21.8 47.4,17 52,17 
				46.8,24.5 52.3,32.5 			"
                />
              </g>
              <g>
                <path
                  class="st1"
                  d="M50.3,24.7c0-4.5,3.3-8.1,8-8.1c4.6,0,7.7,3.5,7.7,8.5V26H54.6c0.3,2,1.8,3.6,4.4,3.6c1.3,0,3.1-0.6,4.1-1.5
				l1.8,2.6c-1.5,1.4-4,2.1-6.4,2.1C53.9,32.8,50.3,29.7,50.3,24.7 M58.3,19.9c-2.5,0-3.6,1.9-3.8,3.4h7.6
				C62,21.8,61,19.9,58.3,19.9"
                />
              </g>
              <g>
                <path
                  class="st1"
                  d="M65.7,30.4l1.8-2.8c1.1,1.1,3.4,2.1,5.3,2.1c1.8,0,2.6-0.7,2.6-1.7c0-2.6-9.2-0.5-9.2-6.6
				c0-2.6,2.3-4.9,6.3-4.9c2.6,0,4.7,0.9,6.2,2.1l-1.6,2.8c-0.9-1-2.7-1.8-4.6-1.8c-1.5,0-2.4,0.7-2.4,1.5c0,2.3,9.1,0.4,9.1,6.6
				c0,2.8-2.4,5-6.7,5C69.9,32.8,67.3,31.9,65.7,30.4"
                />
              </g>
              <g>
                <path
                  class="st1"
                  d="M82.9,32.5c0,0-0.1,0-0.1,0c-1.7-0.7-3.2-2.2-3.2-4.7c0-3.6,2.9-5,5.4-5c2,0,3.9,0.7,4.9,1.9v-2.1
				c0-1.6-1.3-2.6-3.4-2.6c-1.7,0-3.2,0.6-4.5,1.8l-1.5-2.7c1.9-1.7,4.3-2.4,6.7-2.4c3.5,0,6.7,1.4,6.7,5.9v10L82.9,32.5z
				 M89.9,28.8v-1.9c-0.7-0.9-2-1.3-3.3-1.3c-1.6,0-2.9,0.8-2.9,2.3c0,1.4,1.3,2.3,2.9,2.3C87.9,30.1,89.2,29.6,89.9,28.8"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M35.6,16.3C35.1,7.6,27.9,0.7,19.2,0.7c0,0,0,0,0,0c-9.1,0-16.4,7.3-16.5,16.4c0,6.1,3.4,11.5,8.4,14.3
				c0.1,0.1,0.2,0.1,0.4,0.2c2.1,1.1,4.4,1.8,6.9,1.9l17.2,0h0L35.6,16.3L35.6,16.3z"
                />
              </g>
              <g>
                <path
                  class="st2"
                  d="M27.5,16.6c-2.4,0-4.9,0.8-6.7,2.4l1.5,2.7c1.3-1.2,2.8-1.8,4.5-1.8c2,0,3.4,1,3.4,2.6v2.1
				c-1-1.2-2.8-1.9-4.9-1.9c-2.5,0-5.4,1.4-5.4,5c0,2.4,1.4,4,3.2,4.7c0,0,0.1,0,0.1,0l11,0v-10C34.3,18,31.1,16.6,27.5,16.6z
				 M30.2,28.8c-0.7,0.9-2,1.3-3.3,1.3c-1.6,0-2.9-0.8-2.9-2.3c0-1.5,1.3-2.3,2.9-2.3c1.3,0,2.6,0.4,3.3,1.3V28.8z"
                />
              </g>
            </g>
          </g>
          <path
            class="st1 bolita"
            d="M152.7,13.7c0-0.5,0.2-0.9,0.5-1.3c0.3-0.3,0.8-0.5,1.4-0.5c0.6,0,1.1,0.2,1.4,0.5c0.3,0.3,0.5,0.8,0.5,1.3
	c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.3-0.8,0.5-1.4,0.5c-0.6,0-1.1-0.2-1.4-0.5C152.8,14.7,152.7,14.3,152.7,13.7z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import { SubscriberService } from "../services/subscriber.service";
export default {
  name: "loadingpr",
  async created() {
    const roll = localStorage.getItem("roll");
    const subscriberId = localStorage.getItem("subscriberId");
    const businessUnitId = localStorage.getItem("businessUnitId");

    if (roll === "Administrator" || roll === "Consulting") {
      setTimeout(() => this.$router.push({ path: "/consulta" }), 3000);
    } else if (roll === "Customer") {
      const client = await new SubscriberService(this).getSubcriber(
        subscriberId
      );

      this.$store.commit("FillClient", client);
      const { comercialName, googleCustomerId } = client;

      setTimeout(
        () =>
          this.$router.push({
            path: `/cliente/${subscriberId}/businessUnit/${businessUnitId}/clientComercialName/${comercialName}/?customerId=${googleCustomerId}`
          }),
        2000
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.loading-wrapper {
  background-color: $blueish-gray-100;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.st0 {
  fill: #29a9e1;
}
.st1 {
  fill: #808083;
}
.st2 {
  fill: #ffffff;
}

.animation-wrapper {
  align-self: center;
  max-width: 600px;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
}

.wordmark {
  animation-duration: 2s;
  animation-name: wordmarkAnim;
  text-align: center;
  transform: scale(1.2);
  svg {
    width: 100%;
  }
}

.bolita {
  animation-name: bolitaAnim;
  animation-duration: 2.5s;
  // animation: bolitaAnimInfinite 1.3s infinite;
  transform: scaleY(1);
  transform-origin: 20% 40%;
}

@keyframes bolitaAnim {
  0% {
    transform: scaleY(1.8);
    transform-origin: 0% 60%;
    opacity: 0;
  }
  60% {
    transform: scaleY(1.8);
    opacity: 0;
  }
  80% {
    transform: scaleY(0.5);
    transform-origin: 0% 50%;
    opacity: 1;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 0% 40%;
    opacity: 1;
  }
}

@keyframes bolitaAnimInfinite {
  0% {
    transform: scaleY(0.8);
    opacity: 1;
  }

  50% {
    transform: scaleY(1.5);
    opacity: 1;
  }

  100% {
    transform: scaleY(0.8);
    opacity: 1;
  }
}

@keyframes wordmarkAnim {
  0% {
    margin-top: -200px;
    opacity: 0;
  }
  30% {
    opacity: 0;
  }
  80% {
    margin-top: 0px;
    opacity: 1;
  }
}
</style>
